export const DEBOUNCE_TIMEOUT_UPDATE_AMOUNT = 500
export const DEBOUNCE_CART_INFO = 500

export const PRODUCT_NO_PHOTO_PATH = import.meta.env.VITE_PRODUCT_NO_PHOTO_PATH || '/icons/nophoto-logo.svg'

export const CATEGORY_DEFAULT_ICON_PATH = import.meta.env.VITE_CATEGORY_DEFAULT_ICON_PATH || '/icons/category-default-icon.svg'